<template>
  <div>
    <StoreSwitcher v-if="isAdmin" />
    <ProductsReportFilter v-model="filter" @filter="loadSales" />
    <SalesPerProductReportList
      hide-warnings
      :payments="processedSales"
      @refresh="loadSales"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import withAsyncAction from '@/mixins/withAsyncAction'
import services from '@/services'
import ProductsReportFilter from './ProductsReportFilter'
import SalesPerProductReportList from './salesPerProductsReportList.vue'
import { formatDate } from '@/helpers/date'
import StoreSwitcher from '@/components/Stores/StoreSwitcher'

export default {
  name: 'SalesPerProduct',
  components: {
    ProductsReportFilter,
    SalesPerProductReportList,
    StoreSwitcher
  },
  mixins: [
    withAsyncAction({
      key: 'sales',
      initialState: [],
      fetcher: {
        methodName: 'fetchSalesPerProductReport',
        handler: services.reports.fetchSalesPerProductReport
      }
    })
  ],
  data() {
    return {
      filter: {
        fromDate: formatDate(new Date()),
        toDate: formatDate(new Date())
      }
    }
  },
  computed: {
    ...mapGetters('store', ['currentStoreId', 'isAdmin']),

    processedSales() {
      // this.sales é um objeto { data: [...], isLoading: ..., error: ... }
      const salesState = this.sales || []
      console.log('>>>sales<<<')
      console.log(salesState)
      console.log('>>>sales<<<')
      // Extrai o array original (ou vazio, se undefined)

      return salesState
    }
  },
  created() {
    this.loadSales()
  },
  methods: {
    loadSales() {
      const storeId = this.currentStoreId
      const { fromDate, toDate } = this.filter
      this.fetchSalesPerProductReport({ storeId, fromDate, toDate })
    }
  }
}
</script>
